
import React from 'react'
import { SalesOfferForm } from '../components/sales-offer-form'

export const SalesOfferPage: React.FC = () => <SalesOfferForm />